<template>
  <div style="display: inline-block;">
    <el-date-picker
      v-model="value"
      type="year"
      placeholder="选择年"
      size="mini"
      :clearable="false"
      @change="handlePickerChange"
    >
    </el-date-picker>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  model: {
    prop: 'year',
    event: 'input'
  },
  props: ['year'],
  data() {
    return {
      value: ''
    }
  },
  watch: {
    year: {
      handler (val) {
        this.value = `${val}-01-01`;  // 日期格式化，避免datePicker组件格式化错误
      },
      immediate: true
    }
  },
  methods: {
    handlePickerChange(data) {
      this.$emit('input', moment(data).format('YYYY'));
      this.$emit('change', moment(data).format('YYYY'));
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
    width 100px
</style>